var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMovie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8997 9.89502L20.4996 11.5792V9.89502H18.8997Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4896 9.05273H12.9162L16.1813 12.4655H13.144L9.87894 9.05273H7.14448L10.4095 12.4655H7.37224L4.55235 9.51802C4.51885 9.60439 4.5 9.69861 4.5 9.79755V19.0648C4.5 19.5813 4.90064 20.0001 5.39486 20.0001H19.605C20.0992 20.0001 20.4998 19.5813 20.4998 19.0648V12.4655H18.7547L15.4896 9.05273Z",
    fill: "#545454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0998 4L15.329 4.40351L12.4999 8.21053L15.2708 7.80707L18.0998 4Z",
    fill: "#545454"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 4.84229L9.81384 5.22414L6.89978 9.05281L9.58571 8.67091L12.4997 4.84229Z",
    fill: "#545454"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4921 6.39074L20.238 4.84229L18.1 7.3686L19.8544 7.14427C20.2663 7.0916 20.5518 6.75427 20.4921 6.39074Z",
    fill: "#545454"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89997 5.68442L5.12715 5.91134C4.72708 5.96257 4.44969 6.29073 4.50766 6.64428L4.73304 8.0189L4.76448 8.21073L5.49799 7.34299L6.89997 5.68442Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMovie);
export default __webpack_public_path__ + "static/media/ic-movie.3d46f0dc3753736ef0cb7b70422758e2.svg";
export { ForwardRef as ReactComponent };